module.exports = __webpack_public_path__ + "img/property.0698750e.png";